export type ContractType = 'Full-time' | 'Part-time' | 'Casual';

export interface Location {
  _id: string;
  name: string;
  address?: string;
  description?: string;
  shiftStaffCount: number;
  contractType: ContractType;
  createdAt: Date;
  contactPerson: string;
  contactPhone: string;
}

export const CONTRACT_TYPES: ContractType[] = ['Full-time', 'Part-time', 'Casual'];
